<template>
  <h3>
    {{ replacedText }}
  </h3>
</template>

<script>
import { getParameterByName } from "./../../helpers";

export default {
  name: "DonationTitle",
  data: function () {
    return {
      firstName: null,
      replacedText: "",
    };
  },
  props: {
    anonymousText: {
      default: "We're fundraising for the future of our planet",
    },
    customText: {
      default:
        "Hello {{firstName}}, we're fundraising for the future of our planet",
    },
  },
  created: function () {
    let q = getParameterByName("q", window.top.location.href);
    if (q) {
      let decodeq = "?" + window.atob(q);
      this.firstName = getParameterByName("firstname", decodeq);
    }

    if (
      this.firstName &&
      this.firstName.trim() &&
      this.firstName != "null" &&
      this.firstName != "undefined"
    ) {
      this.replacedText = this.customText.replace(
        /{{firstName}}/gi,
        this.firstName
      );
    } else {
      this.replacedText = this.anonymousText;
    }
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// DonateTitle.vue?a8e8bd8e